import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DispatchingAction } from '@app-types/api/dispatching';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MailAccountGetByOrganizationIdContract } from 'src/app/types/api/mail-account';
import { TranslateModule } from '@ngx-translate/core';
import { sortByTextField } from 'src/app/shared/utils/sortData';
import {
  SearchableSelectComponent,
  SearchableSelectOption,
} from '@app-components/common/searchable-select/searchable-select.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reassign-action',
  templateUrl: './reassign-action.component.html',
  styleUrls: ['./reassign-action.component.scss'],
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SearchableSelectComponent,
  ],
})
export class ReassignActionComponent implements OnInit, OnDestroy {
  @Input() dispatchingAction: DispatchingAction;
  @Input() mailAccounts: MailAccountGetByOrganizationIdContract[];

  public form: UntypedFormGroup;
  public mailAccountOptions: SearchableSelectOption<string>[] = [];

  private valueChangesSub?: Subscription;

  ngOnInit(): void {
    this.mailAccountOptions = sortByTextField(
      this.mailAccounts.map(account => ({
        value: account.email,
        label: account.email,
      })),
      'label'
    );

    const initialEmail =
      this.dispatchingAction.args?.[0]?.value ||
      this.mailAccounts[0]?.email ||
      null;

    if (initialEmail) {
      this.setMailAccountValue(initialEmail);
    }

    this.form = new UntypedFormGroup({
      mailAccount: new UntypedFormControl(initialEmail, Validators.required),
    });

    this.valueChangesSub =
      this.form.controls.mailAccount.valueChanges.subscribe(value => {
        if (typeof value === 'string' && value) {
          this.setMailAccountValue(value);
        }
      });
  }

  setMailAccountValue(email: string): void {
    this.dispatchingAction.args = [];
    this.dispatchingAction.args[0] = {
      name: 'MailAccountToReassign',
      value: email,
    };
  }

  ngOnDestroy(): void {
    this.valueChangesSub?.unsubscribe();
  }
}
